import { render, staticRenderFns } from "./DashboardSwitcher.vue?vue&type=template&id=5b06bb30&scoped=true&"
import script from "./DashboardSwitcher.vue?vue&type=script&lang=js&"
export * from "./DashboardSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSwitcher.vue?vue&type=style&index=0&id=5b06bb30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06bb30",
  null
  
)

export default component.exports